import { AssetDepartmentInterface } from "../../models/AssetModel/AssetDepartment";
import client from "../client";

class AssetDepartmentService {
  async GetAll(page: number, pageSize: number) {
    try {
      let url = `/api/AssetDepartments`;
      if (page > 0 && pageSize > 0) {
        url += `?page=${page}&pageSize=${pageSize}`;
      }
      const { data } = await client.get<AssetDepartmentInterface[]>(url);
      return data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  async GetById(id: string) {
    try {
      let url = `/api/AssetDepartments/getbyid/${id}`;

      const { data } = await client.get<AssetDepartmentInterface>(url);

      return data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  async Save(customer: AssetDepartmentInterface) {
    try {
      let url = `/api/AssetDepartments`;

      const { data } = await client.post<AssetDepartmentInterface>(
        url,
        customer
      );

      return data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  async Update(id: string, customer: AssetDepartmentInterface) {
    try {
      let url = `/api/AssetDepartments/update/${id}`;

      const { data } = await client.post<AssetDepartmentInterface>(
        url,
        customer
      );

      return data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }
  async Remove(id: string) {
    try {
      let url = `api/AssetDepartments/remove/${id}`;
      await client.post<AssetDepartmentInterface>(url, { url: "" });
    } catch (error) {
      console.log(error);
      throw error;
    }
  }
}

export default new AssetDepartmentService();
